module.exports = __webpack_public_path__ + "static/media/thumbsup.7ed54960.svg";